import { applicableStyles } from 'Shared/frontend/applicableStyles';
import { PathElement, IStyleDetails } from 'Shared/frontend/widgets/StylesProvider';


/*
	The css a Style Builder rule resolves to for a menu leaf element the menu page tags with a 'menu-*'
	class of its own - the section heading, an item name, a section-jump button. It adds a class-only
	step to the style path the same way Component.tsx adds one for a text component's type, so a rule
	stored at that location class (see locationClasses.ts) lands on the element.
*/
export function menuPartCss(stylePath:PathElement[], styleDetails:IStyleDetails[], aClass:string)
{
	return applicableStyles([...stylePath,{key:'*',classes:[aClass]}],styleDetails).css;
}
